module.exports = __webpack_public_path__ + "img/roche-logo.371152ea.png";